import { jsx } from "react/jsx-runtime";
import { flatMap } from "lodash-es";
import { forEach } from "lodash-es";
import React, { useCallback, useRef } from "react";
export const CellDragHandle = ({
  thisTable,
  onDragEnd,
  cellId,
  isSelectionARectangle
}) => {
  const xStart = useRef(0);
  const timeoutkey = useRef();
  const rowsToSelect = useRef();
  const rectangleCellPaths = useRef();
  const handleDrag = useCallback(
    (e) => {
      const table = thisTable.querySelector(".rt-table");
      const trs = table.querySelectorAll(`.rt-tr-group.with-row-data`);
      const [rowId, path] = cellId.split(":");
      const selectedTr = table.querySelector(
        `.rt-tr-group.with-row-data[data-test-id="${rowId}"]`
      );
      if (!selectedTr) return;
      const selectedIndex = selectedTr.dataset.index;
      if (selectedTr && trs.length) {
        const selectedY = selectedTr.getBoundingClientRect().y;
        const cursorY = e.clientY;
        clearTimeout(timeoutkey.current);
        const updateScrollIfNecessary = () => {
          const { y, height } = table.getBoundingClientRect();
          if (cursorY < y) {
            table.scrollBy(0, -5);
          } else if (cursorY > y + height) {
            table.scrollBy(0, 5);
          }
        };
        updateScrollIfNecessary();
        timeoutkey.current = setInterval(() => {
          updateScrollIfNecessary();
        }, 10);
        const isCursorBelow = cursorY > selectedY;
        rowsToSelect.current = [];
        forEach(trs, (tr, index) => {
          let isSelectedForUpdate;
          const rowId2 = tr.dataset.testId;
          const changeDashedBorder = (path2, on) => {
            tr.querySelector(
              `[data-test="tgCell_${path2}"]`
            ).parentNode.classList[on ? "add" : "remove"]("selectedForUpdate");
          };
          if (isCursorBelow ? index > selectedIndex : index < selectedIndex) {
            const { y, height } = tr.getBoundingClientRect();
            if (isCursorBelow ? y < cursorY : y + height > cursorY) {
              rowsToSelect.current.push(rowId2);
              isSelectedForUpdate = true;
              if (rectangleCellPaths.current) {
                rectangleCellPaths.current.forEach((path2) => {
                  changeDashedBorder(path2, true);
                });
              } else {
                changeDashedBorder(path, true);
              }
            }
          }
          if (!isSelectedForUpdate) {
            if (rectangleCellPaths.current) {
              rectangleCellPaths.current.forEach((path2) => {
                changeDashedBorder(path2, false);
              });
            } else {
              changeDashedBorder(path, false);
            }
          }
        });
      }
    },
    [cellId, thisTable]
  );
  const onMouseUp = useCallback(() => {
    clearTimeout(timeoutkey.current);
    const table = thisTable;
    const trs = table.querySelectorAll(`.rt-tr-group.with-row-data`);
    const [, path] = cellId.split(":");
    forEach(trs, (tr) => {
      if (rectangleCellPaths.current) {
        rectangleCellPaths.current.forEach((path2) => {
          const el = tr.querySelector(`[data-test="tgCell_${path2}"]`);
          el.parentNode.classList.remove("selectedForUpdate");
        });
      } else {
        const el = tr.querySelector(`[data-test="tgCell_${path}"]`);
        el.parentNode.classList.remove("selectedForUpdate");
      }
    });
    document.removeEventListener("mousemove", handleDrag, false);
    document.removeEventListener("mouseup", onMouseUp, false);
    onDragEnd(
      flatMap(rowsToSelect.current, (id) => {
        if (rectangleCellPaths.current) {
          return rectangleCellPaths.current.map((path2) => {
            return `${id}:${path2}`;
          });
        } else {
          return `${id}:${path}`;
        }
      })
    );
  }, [cellId, handleDrag, onDragEnd, thisTable]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      onMouseDown: (e) => {
        rowsToSelect.current = [];
        xStart.current = e.clientX;
        const { isRect, selectedPaths } = isSelectionARectangle();
        if (isRect) {
          rectangleCellPaths.current = selectedPaths;
        }
        document.addEventListener("mousemove", handleDrag, false);
        document.addEventListener("mouseup", onMouseUp, false);
      },
      className: "cellDragHandle"
    }
  );
};
